import useSearch from '../contexts/useSearch';
import ItemRowSkeleton from './ItemRowSkeleton';
import type { ListData } from '../../../types';

interface SearchResultsProps {
  renderResult: (item: ListData) => React.ReactNode;
  excludeIds?: string[];
}

const SearchResults = ({
  renderResult,
  excludeIds = [],
}: SearchResultsProps) => {
  const { results, addResult, isSearching, addingUrl, isSearchActive } =
    useSearch();

  // Don't render anything if search isn't active
  if (!isSearchActive) {
    return null;
  }

  return (
    <>
      {isSearching && <ItemRowSkeleton message="Searching..." />}
      {addingUrl && <ItemRowSkeleton message="Fetching URL..." />}
      {addResult && typeof addResult === 'string' && (
        <ItemRowSkeleton message={`Error: ${addResult}`} />
      )}
      {addResult &&
        typeof addResult !== 'string' &&
        !excludeIds.includes(addResult.id) &&
        renderResult(addResult)}
      {results
        .filter((item) => !excludeIds.includes(item.id))
        .map((item) => (
          <div key={`search-result-${item.id}`}>{renderResult(item)}</div>
        ))}
    </>
  );
};

export default SearchResults;
